module.exports = __webpack_public_path__ + "static/media/message.a0b94536.svg";